import React from 'react';
import {useDroppable} from '@dnd-kit/core';
import PropTypes from 'prop-types';

export function Droppable({ children }) {
   

  console.log("Dropable",children);
  const {isOver, setNodeRef} = useDroppable({
    id: 'droppable',
  });
  const style = {
    color: isOver ? 'green' : undefined,
  };
  
  
  return (
    <div ref={setNodeRef} style={style}>
      { children }
    </div>
  );
}

Droppable.propTypes = {
    children: PropTypes.node,
  };